import React from 'react';
import { useNavigate } from 'react-router-dom';
import appstore from '../assets/images/appstore.png';
import playstore from '../assets/images/playstore.png';

const SignupInstructions = () => {
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    navigate('/');
  };

  // App store links - replace with your actual links
  const handleAppStoreClick = () => {
    window.open('https://apps.apple.com/app/id6744721098', '_blank');
  };

  const handlePlayStoreClick = () => {
    window.open('https://play.google.com/store/apps/details?id=com.mnk.vreels', '_blank');
  };

  return (
    <div className="signup-instructions-container">
      <div className="signup-instructions-content">
        <div className="instructions-section">
          <div className="instructions-header">
            <h1 className="instructions-title">Download Our App</h1>
            <p className="instructions-subtitle">
              Get started with your vendor account by downloading our mobile app
            </p>
          </div>

          <div className="app-downloads">
            <img
              src={appstore}
              alt="Download on App Store"
              className="store-image appstore-image"
              onClick={handleAppStoreClick}
            />

            <img
              src={playstore}
              alt="Get it on Google Play"
              className="store-image playstore-image"
              onClick={handlePlayStoreClick}
            />
          </div>

          <div className="instructions-body">
            <div className="instruction-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Download the app for your device</h3>
                <p>Choose your platform above and install the app</p>
              </div>
            </div>

            <div className="instruction-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Signup in the app</h3>
                <p>Create your account using the same mobile number</p>
              </div>
            </div>

            <div className="instruction-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Return to login with same mobile number to setup the vendor account</h3>
                <p>Come back here and use the same number to complete your vendor setup</p>
              </div>
            </div>
          </div>

          <div className="instructions-footer">
            <button
              onClick={handleBackToLogin}
              className="btn btn-primary back-to-login-btn"
            >
              ← Back to Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupInstructions;
